/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardLayoutRouteImport } from './routes/_dashboard-layout'
import { Route as AuthLayoutRouteImport } from './routes/_auth-layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardLayoutStationsRouteImport } from './routes/_dashboard-layout/stations'
import { Route as DashboardLayoutShiftsRouteImport } from './routes/_dashboard-layout/shifts'
import { Route as DashboardLayoutServicesRouteImport } from './routes/_dashboard-layout/services'
import { Route as DashboardLayoutPaymentsRouteImport } from './routes/_dashboard-layout/payments'
import { Route as DashboardLayoutMastersRouteImport } from './routes/_dashboard-layout/masters'
import { Route as DashboardLayoutBranchesRouteImport } from './routes/_dashboard-layout/branches'
import { Route as DashboardLayoutAppointmentsRouteImport } from './routes/_dashboard-layout/appointments'
import { Route as AuthLayoutLoginRouteImport } from './routes/_auth-layout/login'

const DashboardLayoutRoute = DashboardLayoutRouteImport.update({
  id: '/_dashboard-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLayoutStationsRoute = DashboardLayoutStationsRouteImport.update({
  id: '/stations',
  path: '/stations',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutShiftsRoute = DashboardLayoutShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutServicesRoute = DashboardLayoutServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutPaymentsRoute = DashboardLayoutPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutMastersRoute = DashboardLayoutMastersRouteImport.update({
  id: '/masters',
  path: '/masters',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutBranchesRoute = DashboardLayoutBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => DashboardLayoutRoute,
} as any)
const DashboardLayoutAppointmentsRoute =
  DashboardLayoutAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => DashboardLayoutRoute,
  } as any)
const AuthLayoutLoginRoute = AuthLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof AuthLayoutLoginRoute
  '/appointments': typeof DashboardLayoutAppointmentsRoute
  '/branches': typeof DashboardLayoutBranchesRoute
  '/masters': typeof DashboardLayoutMastersRoute
  '/payments': typeof DashboardLayoutPaymentsRoute
  '/services': typeof DashboardLayoutServicesRoute
  '/shifts': typeof DashboardLayoutShiftsRoute
  '/stations': typeof DashboardLayoutStationsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof AuthLayoutLoginRoute
  '/appointments': typeof DashboardLayoutAppointmentsRoute
  '/branches': typeof DashboardLayoutBranchesRoute
  '/masters': typeof DashboardLayoutMastersRoute
  '/payments': typeof DashboardLayoutPaymentsRoute
  '/services': typeof DashboardLayoutServicesRoute
  '/shifts': typeof DashboardLayoutShiftsRoute
  '/stations': typeof DashboardLayoutStationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth-layout': typeof AuthLayoutRouteWithChildren
  '/_dashboard-layout': typeof DashboardLayoutRouteWithChildren
  '/_auth-layout/login': typeof AuthLayoutLoginRoute
  '/_dashboard-layout/appointments': typeof DashboardLayoutAppointmentsRoute
  '/_dashboard-layout/branches': typeof DashboardLayoutBranchesRoute
  '/_dashboard-layout/masters': typeof DashboardLayoutMastersRoute
  '/_dashboard-layout/payments': typeof DashboardLayoutPaymentsRoute
  '/_dashboard-layout/services': typeof DashboardLayoutServicesRoute
  '/_dashboard-layout/shifts': typeof DashboardLayoutShiftsRoute
  '/_dashboard-layout/stations': typeof DashboardLayoutStationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/appointments'
    | '/branches'
    | '/masters'
    | '/payments'
    | '/services'
    | '/shifts'
    | '/stations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/appointments'
    | '/branches'
    | '/masters'
    | '/payments'
    | '/services'
    | '/shifts'
    | '/stations'
  id:
    | '__root__'
    | '/'
    | '/_auth-layout'
    | '/_dashboard-layout'
    | '/_auth-layout/login'
    | '/_dashboard-layout/appointments'
    | '/_dashboard-layout/branches'
    | '/_dashboard-layout/masters'
    | '/_dashboard-layout/payments'
    | '/_dashboard-layout/services'
    | '/_dashboard-layout/shifts'
    | '/_dashboard-layout/stations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  DashboardLayoutRoute: typeof DashboardLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard-layout': {
      id: '/_dashboard-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout': {
      id: '/_auth-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard-layout/stations': {
      id: '/_dashboard-layout/stations'
      path: '/stations'
      fullPath: '/stations'
      preLoaderRoute: typeof DashboardLayoutStationsRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/shifts': {
      id: '/_dashboard-layout/shifts'
      path: '/shifts'
      fullPath: '/shifts'
      preLoaderRoute: typeof DashboardLayoutShiftsRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/services': {
      id: '/_dashboard-layout/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof DashboardLayoutServicesRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/payments': {
      id: '/_dashboard-layout/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof DashboardLayoutPaymentsRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/masters': {
      id: '/_dashboard-layout/masters'
      path: '/masters'
      fullPath: '/masters'
      preLoaderRoute: typeof DashboardLayoutMastersRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/branches': {
      id: '/_dashboard-layout/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof DashboardLayoutBranchesRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_dashboard-layout/appointments': {
      id: '/_dashboard-layout/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof DashboardLayoutAppointmentsRouteImport
      parentRoute: typeof DashboardLayoutRoute
    }
    '/_auth-layout/login': {
      id: '/_auth-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLayoutLoginRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutLoginRoute: typeof AuthLayoutLoginRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutLoginRoute: AuthLayoutLoginRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface DashboardLayoutRouteChildren {
  DashboardLayoutAppointmentsRoute: typeof DashboardLayoutAppointmentsRoute
  DashboardLayoutBranchesRoute: typeof DashboardLayoutBranchesRoute
  DashboardLayoutMastersRoute: typeof DashboardLayoutMastersRoute
  DashboardLayoutPaymentsRoute: typeof DashboardLayoutPaymentsRoute
  DashboardLayoutServicesRoute: typeof DashboardLayoutServicesRoute
  DashboardLayoutShiftsRoute: typeof DashboardLayoutShiftsRoute
  DashboardLayoutStationsRoute: typeof DashboardLayoutStationsRoute
}

const DashboardLayoutRouteChildren: DashboardLayoutRouteChildren = {
  DashboardLayoutAppointmentsRoute: DashboardLayoutAppointmentsRoute,
  DashboardLayoutBranchesRoute: DashboardLayoutBranchesRoute,
  DashboardLayoutMastersRoute: DashboardLayoutMastersRoute,
  DashboardLayoutPaymentsRoute: DashboardLayoutPaymentsRoute,
  DashboardLayoutServicesRoute: DashboardLayoutServicesRoute,
  DashboardLayoutShiftsRoute: DashboardLayoutShiftsRoute,
  DashboardLayoutStationsRoute: DashboardLayoutStationsRoute,
}

const DashboardLayoutRouteWithChildren = DashboardLayoutRoute._addFileChildren(
  DashboardLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  DashboardLayoutRoute: DashboardLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
